import React from 'react'
import Imagen from '../../models/Imagen'

import './GaleriaImagenes.scss';

type Props = {
    nombreGaleria: string,
    imagenes: Imagen[],
    esModal?: boolean
}

const GaleriaImagenes = ({nombreGaleria, imagenes, esModal= false}: Props) => {

    const estilosCarousel = esModal?"carousel-inner carousel-imagenes carousel-imagenes-modal":"carousel-inner carousel-imagenes";

    const pintarItemsImagenes = () => {

        const itemImagenes = imagenes.map((imagen: Imagen, index: number) => {

            const estiloImagen = (index === 0)?"carousel-item active":"carousel-item"

            return (
                <div className={estiloImagen}  key={index}>
                    <img src={imagen.path} className="d-block entorno" alt={imagen.descripcion} />
                </div>
            )
        })

        return (
            <div className={estilosCarousel}>
                {
                    itemImagenes
                }
            </div>
        )

    }

  return (
    
    <div id={`galeria_`+ nombreGaleria} className="carousel slide" data-bs-ride="carousel">
                        
        {
            pintarItemsImagenes()
        }

        <button className="carousel-control-prev" type="button" data-bs-target={`#galeria_` + nombreGaleria} data-bs-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Previous</span>
        </button>

        <button className="carousel-control-next" type="button" data-bs-target={`#galeria_` + nombreGaleria} data-bs-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Next</span>
        </button>

    </div>

  )
}

export default GaleriaImagenes